import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.3/js/sparta-events-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";
import spartaTransportUtility from "utilities/global/sparta-transport-utility/4.0.2/js/sparta-transport-utility";

















const utilityNamespace = 'DataAssetLoader';






const EVENTS = {
  ASSET_LOADED: `ASSET_LOADED.${utilityNamespace}`,
  ASSET_FAILED: `ASSET_FAILED.${utilityNamespace}`,
};







function getRequireVersion() {

  let requireObj;


  const widgetContext = spartaStoreUtility.getData('applicationContext');


  if (widgetContext) {

    requireObj = window.sparta.require[widgetContext.name][widgetContext.version].require;
  } else {

    requireObj = require;
  }


  return requireObj;
}







function ajaxComplete(xhr, filename, events) {

  const evtData = {
    filename,
    xhr,
  };



  if ((xhr.status >= 200 && xhr.status < 400) || (!xhr.status && !xhr.DONE)) {

    spartaEventsUtility.pub(events.success, evtData);
  } else {

    spartaEventsUtility.pub(events.failure, evtData);
  }
}






function requireComplete(filename, events) {

  spartaEventsUtility.pub(events.require, {filename});
}






class DataAssetLoader {







  constructor(utilityString, loadPath = 'data') {

    if (utilityString) {

      this.callerNamespace = utilityString;

      try {

        this.require = getRequireVersion();


        this.config = this.getImporterConfig(utilityString, loadPath);
      } catch (e) {
        console.warn(`DATA ASSET LOADER: ${e}`);
      }
    }
  }






  get EVENTS() {
    return EVENTS;
  }









  getImporterConfig(utilityString, loadPath) {

    const basePathRegex = new RegExp(`.*?/${utilityString}/(\\d+.\\d+.\\d+-[a-zA-Z]+|\\d+.\\d+.\\d+)`, 'g');


    const basePathResult = this.require.toUrl(utilityString).match(basePathRegex)[0];


    return {
      utilityString,
      basePathResult,
      loadPath,
    };
  }









  loadAsset(filename, type = 'json') {

    if (filename && this.config) {

      const success = `${this.EVENTS.ASSET_LOADED}.${this.callerNamespace}.${filename}`;
      const failure = `${this.EVENTS.ASSET_FAILED}.${this.callerNamespace}.${filename}`;


      const jsonEvents = {
        success,
        failure,
      };


      const requireEvents = {
        require: success,
      };


      switch (type) {
        case 'js':
          this.loadScript(filename, requireEvents);

          break;
        case 'css':
          this.loadStylesheet(filename, requireEvents);

          break;
        case 'json':
        default:
          this.loadViaAjax(filename, jsonEvents);
      }



      if (type === 'json') {
        return jsonEvents;
      }



      return requireEvents;
    }


    return false;
  }








  loadScript(filename, evts) {

    if (filename) {

      return this.require([`${this.generateAssetURL(filename)}`], requireComplete(filename, evts));
    }

    return false;
  }








  loadStylesheet(filename, evts) {

    if (filename) {

      return this.require([`css!${this.generateAssetURL(filename)}`], requireComplete(filename, evts));
    }

    return false;
  }








  loadViaAjax(filename, evts) {

    if (filename) {

      const subscription = {
        cache: true,
        dataType: 'json',
        method: 'GET',
        error(xhr) {
          ajaxComplete(xhr, filename, evts);
        },
        success(data) {
          ajaxComplete(data, filename, evts);
        },
        url: this.generateAssetURL(filename),
      };


      return spartaTransportUtility.subscribe(subscription);
    }

    return false;
  }








  generateAssetURL(filename) {

    if (this.config) {

      const {basePathResult, loadPath} = this.config;


      return `${basePathResult}/${loadPath}/${filename}`;
    }

    return false;
  }
}


export default DataAssetLoader;
